import { FaWhatsapp } from 'react-icons/fa';
import { CAMPUS_LIST } from '../../../data/campus';
import NavBar from '../../../shared/NavBar';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <NavBar />

      <div className="pt-32 pb-20 px-4 max-w-5xl mx-auto">

        <h1 className="text-5xl md:text-7xl font-black text-black mb-4">Contáctanos</h1>
        <p className="text-gray-400 text-xl mb-16">Estamos listos para escucharte.</p>

        {/* Grid de campus */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {CAMPUS_LIST.map((campus) => (
            <div
              key={campus.slug}
              className="border border-gray-100 rounded-2xl p-8 bg-white shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <h2 className="text-2xl font-black text-black mb-1">{campus.nombre}</h2>
              <p className="text-gray-400 text-sm mb-4">{campus.ciudad}</p>
              <p className="text-gray-500 text-sm mb-2">{campus.direccion}</p>
              <p className="text-gray-500 text-sm mb-8">Tel: {campus.telefono}</p>
              <a
                href={`https://wa.me/${campus.whatsapp}?text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Larghetto%20${campus.nombre}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] hover:brightness-110 text-white text-sm font-semibold transition-all hover:scale-105"
              >
                <FaWhatsapp size={16} />
                WhatsApp
              </a>
            </div>
          ))}
        </div>

        {/* Email */}
        <div className="text-center border-t border-gray-100 pt-12">
          <p className="text-gray-400 text-sm mb-3">También puedes escribirnos a</p>
          <a
            href="mailto:contacto@larghetto.com.mx"
            className="text-black hover:text-gray-600 text-2xl font-black transition-colors"
          >
            contacto@larghetto.com.mx
          </a>
        </div>

      </div>
    </div>
  );
}
